import type { ReactNode } from "react";
import { Tooltip } from "@shopify/polaris";

interface CustomTooltipAdminProps {
    content?: string | ReactNode;
    children: ReactNode;
    hasUnderline?: boolean;
    persistOnClick?: boolean;
}

/**
 * Polaris' Tooltip still shows an empty bubble on hover when `content` is
 * falsy/empty. This skips rendering the Tooltip wrapper entirely in that
 * case, rendering just the children instead.
 */
const CustomTooltipAdmin = ({
    content,
    children,
    hasUnderline = false,
    persistOnClick = false,
}: CustomTooltipAdminProps) => {
    if (!content) return <>{children}</>;
    return (
        <Tooltip content={content} hasUnderline={hasUnderline} persistOnClick={persistOnClick}>
            {children}
        </Tooltip>
    );
};

export default CustomTooltipAdmin;
